import React from "react";
import {produce} from "immer";

export const DEFAULT_STATE = {
    selectedPaxIds: [] as string[],
}

export type PaxNotifierState = typeof DEFAULT_STATE;

type PaxNotifierAction = {
    type: 'SET_SELECTED_PAX_IDS',
    payload: string[]
} | {
    type: 'RESET'
}

export const PaxNotifierReducer: React.Reducer<PaxNotifierState, PaxNotifierAction> = produce((draft, action) => {
    console.log('PaxNotifierReducer action:', action);
    switch (action.type) {
        case 'SET_SELECTED_PAX_IDS':
            draft.selectedPaxIds = action.payload;
            break;
        case 'RESET':
            draft.selectedPaxIds = [];
            break;
    }
})